import React from 'react';
import { ModalComponent } from '../../../components/Modal/ModalComponent';
import { ChatbotLocalizedLabels } from '../types';

interface ThankYouModalProps {
  labels: ChatbotLocalizedLabels;
  isOpen: boolean;
  onClose: () => void;
}

export const ThankYouModal: React.FC<ThankYouModalProps> = ({ labels, isOpen, onClose }) => {
  const footerChild = (
    <button
      type="button"
      className="chatbot-btn chatbot-btn-primary"
      onClick={onClose}
    >
      {labels.close}
    </button>
  );

  const modalObject = {
    showModal: isOpen,
    dialogClass: 'chatbot-exit-modal chatbot-thank-you-dialog',
    head: {
      modalTitle: labels.surveyTitle,
    },
    body: {
      confirmBoxData: {
        messagetext: labels.feedbackThankYouMessage,
      },
    },
    footer: {
      footerChild,
    },
    clickHandler: onClose,
    showHeaderCloseBtn: true,
    css: {
      modalFooter: 'chatbot-thank-you-footer',
    },
  };

  return <ModalComponent modalObject={modalObject} />;
};
